import React from 'react';
import {Container} from 'flux/utils';

import ProductStore from 'stores/ProductStore';
import HttpService from 'service/HttpService';
import ProductAPI from 'service/api/ProductAPI';

import AppConstants from 'AppConstants';

import SetoCanvasPage from 'pages/SetoCanvasPage';
import PhotoFrameForm from 'views/order/PhotoFrameForm';
import SuggestedProducts from 'views/product/SuggestedProducts';

const productId = AppConstants.CUSTOM_FRAME_PRODUCT;

const frameProduct = AppConstants.PRODUCT_TYPES['PHOTO_FRAME'];

class PhotoFramePage extends React.Component{
    static getStores() {
		return [ProductStore];
	}

    static calculateState(prevState, props) {
		let product = ProductStore.getProduct(productId);
		let suggestedProducts = ProductStore.getProductsByType(frameProduct.url);
		const newState = {
				product: product,
				suggestedProducts: suggestedProducts
			};
		return newState;
	}

    componentDidMount() {
		const product = this.state.product;

		if(product === null)
			HttpService.getProduct(productId);

		if(this.state.suggestedProducts === null) {
			ProductAPI.getProductsByType(frameProduct, 0, AppConstants.DEFAULT_PRODUCT_PAGE_SIZE);		
		}
	}

    render() {
        const product = this.state.product;
        return <SetoCanvasPage id="photoFramePage" title={"Custom Photo Frame"} turnOffSticky={true} >
			<PhotoFrameForm product={product}/>

			{
				this.state.suggestedProducts && 
				<SuggestedProducts products={this.state.suggestedProducts} 
						autoplay={true} navigator="arrows" />
			}
        </SetoCanvasPage>
    }

}

export default Container.create(PhotoFramePage, {withProps: true});


// WEBPACK FOOTER //
// ./src/pages/products/PhotoFramePage.js